<template>
  <div class="login-view">
    <div class="login-panel">
      <md-field>
        <label>Email</label>
        <md-input v-model="email"></md-input>
      </md-field>
      <md-field>
        <label>Password</label>
        <md-input type="password" v-model="password"></md-input>
      </md-field>
      <div class="actions">
        <gl-button :disabled="signingIn" primary @click="login"
          >Login</gl-button
        >
      </div>
      <div class="error" v-if="errorMessage">
        {{ errorMessage }}
      </div>

      <!-- Google認証UI用 -->
      <div v-if="enableGoogleSignin" id="auth-ui"></div>
    </div>
  </div>
</template>

<script>
// TODO
// 一般公開までは手動で作成したFirebase認証のユーザーでサインインさせます。
// Firebase UIでログインUIを作成すると、その場でアカウントを作成してサインインが
// できてしまいます。仕方がないのでログイン画面を作成し、入力されたメールアドレス、
// パスワードでサインインします。
// Firebase認証で一般ユーザーがサインインできるようになれば、最終的にはこのView
// は不要になります。

import firebase from 'firebase/app'

function startAuthUi() {
  // eslint-disable-next-line no-undef
  var ui = new firebaseui.auth.AuthUI(firebase.auth())
  ui.start('#auth-ui', {
    signInOptions: [firebase.auth.GoogleAuthProvider.PROVIDER_ID],
    signInSuccessUrl: '/',
  })
}

export default {
  data() {
    return {
      email: undefined,
      password: undefined,
      errorMessage: undefined,
      signingIn: false,
    }
  },
  computed: {
    enableGoogleSignin() {
      if (!process.env.VUE_APP_GOOGLE_SIGNIN_ACTIVATION_KEY) {
        return false
      }
      return (
        process.env.VUE_APP_GOOGLE_SIGNIN_ACTIVATION_KEY ===
        this.$route.query.googleSigninActivationKey
      )
    },
  },
  methods: {
    login() {
      this.errorMessage = undefined
      this.signingIn = true

      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(() => {
          // Vueアプリケーションロード前にログイン済アカウントの
          // 確認が行われるので、サインインしてから再読み込みすればOK
          location.reload()
        })
        .catch(() => {
          this.errorMessage = 'メールアドレス、またはパスワードが違います。'
          this.password = undefined
          this.signingIn = false
        })
    },
  },
  mounted() {
    if (this.enableGoogleSignin) {
      startAuthUi()
    }
  },
}
</script>

<style scoped>
.login-view {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-panel {
  width: 320px;
}

.actions {
  text-align: center;
}

.error {
  color: var(--color-warn);
}

#auth-ui {
  background: gainsboro;
  padding: 32px;
  margin-top: 74px;
}
</style>
